import { render, staticRenderFns } from "./Illness-kind.vue?vue&type=template&id=79889f9a&"
import script from "./Illness-kind.vue?vue&type=script&lang=js&"
export * from "./Illness-kind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports